

import * as Debug from "debug";
var debug = Debug('CRMMap:GoogleObjects');

//from this gist 
//https://gist.github.com/supermock/36d8d9ae7217cbca72f35da149a38e9e

export function GoogleMapsBar(position, vertical = false) {
    var bar = document.createElement("div");
    bar.setAttribute("class", "gmnoprint");
    switch (position) {
        case google.maps.ControlPosition.RIGHT_TOP:
            bar.setAttribute("style", vertical ? "margin: 5px;  margin-right:10px;z-index: 10; position: absolute; top: 0px; right: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; top: 0px; right: 0px;");
            break;
        case google.maps.ControlPosition.RIGHT_CENTER:
            bar.setAttribute("style", "margin: 5px; margin-right:10px; z-index: 10; position: absolute; right: 0px; width: 26px;");
            break;
        case google.maps.ControlPosition.RIGHT_BOTTOM:
            bar.setAttribute("style", vertical ? "margin: 5px;  margin-right:10px; z-index: 10; position: absolute; right: 0px; bottom: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; right: 0px; bottom: 0px;");
            break;
        case google.maps.ControlPosition.LEFT_TOP:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; top: 0px; left: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; top: 0px; left: 0px;");
            break;
        case google.maps.ControlPosition.LEFT_CENTER:
            bar.setAttribute("style", "margin: 5px; z-index: 10; position: absolute; left: 0px; width: 26px;");
            break;
        case google.maps.ControlPosition.LEFT_BOTTOM:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; left: 0px; bottom: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; left: 0px; bottom: 0px;");
            break;
        case google.maps.ControlPosition.BOTTOM_LEFT:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; left: 0px; bottom: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; left: 0px; bottom: 0px;");
            break;
        case google.maps.ControlPosition.BOTTOM_CENTER:
            bar.setAttribute("style", "margin: 5px; z-index: 10; position: absolute; margin-bottom: 2em;");
            break;
        case google.maps.ControlPosition.BOTTOM_RIGHT:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; right: 0px; bottom: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; right: 0px; bottom: 0px;");
            break;
        case google.maps.ControlPosition.TOP_LEFT:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; left: 0px; top: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; left: 0px; top: 0px;");
            break;
        case google.maps.ControlPosition.TOP_CENTER:
            bar.setAttribute("style", "margin: 5px; z-index: 10; position: absolute; top: 0px;");
            break;
        case google.maps.ControlPosition.TOP_RIGHT:
            bar.setAttribute("style", vertical ? "margin: 5px; z-index: 10; position: absolute; right: 0px; top: 0px; width: 26px;" : "margin: 5px; z-index: 10; position: absolute; right: 0px; top: 0px;");
            break;
    }
    return bar;
}

export function GoogleMapsButton(options, onClick, hover: boolean = true) {

    /*
    options: {
        size: {
            width: 18px,
            height: 18px
        },
        icon: {
            name: "fa-name",
            color: "#eee"
        }
    }
     */
    var buttonFrame = document.createElement("div");
    buttonFrame.setAttribute("style", "float: right; line-height: 0;" + (options.size ? "min-width: " + options.size.width + "px; max-width: " + options.size.width + "px; min-height: " + options.size.height + "px; max-height: " + options.size.height + "px;" : ""));
    var button = document.createElement("div");
    button.setAttribute("style", "background-color:rgb(255,255,255); padding: 6px; border-bottom-right-radius: 2px; border-top-right-radius: 2px; box-shadow: rgba(0, 0, 0, 0.298039) 0px 1px 4px -1px; border-left: 0px; text-align: center;");
    button.title = (options.icon && options.icon.hasOwnProperty("title") ? options.icon.title : '');
    button.appendChild((function () {
        var i = document.createElement("i");
        i.setAttribute("class", (options.icon ? options.icon.name : ""));
        i.setAttribute("style", "font-size: 18px;" + (options.icon && options.icon.hasOwnProperty("color") ? "color: " + options.icon.color + "; background-color: " + options.icon.color : ""));
        return i;
    })());


    if (options.icon && options.icon.hasOwnProperty("label")) {
        button.appendChild((function () {
            var d = document.createElement("div");
            d.setAttribute("style", "font-size: 12px;" + (options.icon && options.icon.hasOwnProperty("color") ? "color: " + options.icon.color + "; background-color: " + options.icon.color : ""));
            d.innerHTML = options.icon.label;
            return d;
        })());

    }


    buttonFrame.appendChild(button);
    google.maps.event.addDomListener(button, 'click', (event) => {
        onClick(event, options);
    });
    if (hover) {
        google.maps.event.addDomListener(button, 'mouseover', function () {
            button.style.color = "rgb(0,0,0)";
            button.style.backgroundColor = "rgb(235,235,235)";
        });
        google.maps.event.addDomListener(button, 'mouseout', function () {
            button.style.color = "rgb(86,86,86)";
            button.style.backgroundColor = "rgb(255,255,255)";
        });
    }
    return buttonFrame;
}
export function calculateGeometry(overlay, geometryOnly) {
    debug('Drawing.calculateGeometry', overlay, geometryOnly);
    if (!overlay) {
        console.error('No Overlay, calculateGeometry');
        return false;
    }
    switch (overlay.type) {
        case google.maps.drawing.OverlayType.MARKER:
            return geometryOnly ? new google.maps.Data.Point(overlay.getPosition()) : {
                geometry: new google.maps.Data.Point(overlay.getPosition())
            };
        case google.maps.drawing.OverlayType.RECTANGLE:
            var b = overlay.getBounds(),
                p = [b.getSouthWest(), {
                    lat: b.getSouthWest().lat(),
                    lng: b.getNorthEast().lng()
                }, b.getNorthEast(), {
                    lng: b.getSouthWest().lng(),
                    lat: b.getNorthEast().lat()
                }];
            return geometryOnly ? new google.maps.Data.Polygon([p]) : {
                geometry: new google.maps.Data.Polygon([p])
            };
        case google.maps.drawing.OverlayType.POLYGON:
            return geometryOnly ? new google.maps.Data.Polygon([overlay.getPath().getArray()]) : {
                geometry: new google.maps.Data.Polygon([overlay.getPath().getArray()])
            };
        case google.maps.drawing.OverlayType.POLYLINE:
            return geometryOnly ? new google.maps.Data.LineString(overlay.getPath().getArray()) : {
                geometry: new google.maps.Data.LineString(overlay.getPath().getArray())
            };
        case google.maps.drawing.OverlayType.CIRCLE:

            return geometryOnly ? new google.maps.Data.Feature(overlay.getCenter()) : {
                properties: {
                    radius: overlay.getRadius()
                },
                geometry: new google.maps.Data.Point(overlay.getCenter())
            };
        default:
            console.error("Unhandled Type ", overlay.type, overlay);
            break;

    }
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}

export function isMVCArray(array) {
    return array instanceof google.maps.MVCArray;
}
export function transformToMVCArray(a) {
    // function transformToMVCArray($a, parent) {
    //     if ($a.length == 2 && (!Array.isArray($a[0]) && !Array.isArray($a[1]))) {
    //         parent.push({
    //             lat: $a[1],
    //             lng: $a[0]
    //         });
    //         //console.log($a);
    //     }
    //     for (var a = 0; a < $a.length; a++) {
    //         if (!Array.isArray($a[a])) continue;
    //         transformToMVCArray($a[a], (parent) ? ($a[a].length == 2 && (!Array.isArray($a[a][0]) && !Array.isArray($a[a][1]))) ? parent : parent[parent.push([]) - 1] : clone[clone.push([]) - 1]);
    //     }
    // }
    var clone = new google.maps.MVCArray();

    function transform($a, parent) {
        if ($a.length == 2 && (!Array.isArray($a[0]) && !Array.isArray($a[1])))
            parent.push(new google.maps.LatLng($a[1], $a[0]));
        for (var a = 0; a < $a.length; a++) {
            if (!Array.isArray($a[a])) continue;
            transform($a[a], (parent) ? ($a[a].length == 2 && (!Array.isArray($a[a][0]) && !Array.isArray($a[a][1]))) ? parent : parent.getAt(parent.push(new google.maps.MVCArray()) - 1) : clone.getAt(clone.push(new google.maps.MVCArray()) - 1));
        }
    }

    function isMVCArray(array) {
        return array instanceof google.maps.MVCArray;
    }

    transform(a, null);
    return clone;
}
export function getBoundsZoomLevel(bounds, mapDim) {
    var WORLD_DIM = { height: 256, width: 256 };
    var ZOOM_MAX = 21;

    function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    }

    function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    }

    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();

    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;

    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = ((lngDiff < 0) ? (lngDiff + 360) : lngDiff) / 360;

    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);

    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}


export function instanceOverlay(feature, polyOptions) {
    var instance = null;

    debug('instanceOverlay', feature.properties.type);
    if (!feature.geometry) {
        console.error('No feature Geometry?', feature);
        return false;
    }

   var tmplocationId = 0;

    switch (feature.properties.type) {
        case google.maps.drawing.OverlayType.MARKER:
            instance = new google.maps.Marker({
                position: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
                draggable: true
            });
            break;
        case google.maps.drawing.OverlayType.RECTANGLE:
            var NE = new google.maps.LatLng(feature.geometry.coordinates[0][2][1], feature.geometry.coordinates[0][2][0]);
            var SW = new google.maps.LatLng(feature.geometry.coordinates[0][0][1], feature.geometry.coordinates[0][0][0]);
            instance = new google.maps.Rectangle(Object.assign({}, polyOptions, {
                type: feature.properties.type,
                fillColor: feature.properties.color,
                bounds: new google.maps.LatLngBounds(SW, NE),
                editable: false,
                locationId: tmplocationId
            }));
            break;
        case google.maps.drawing.OverlayType.POLYGON:
            instance = new google.maps.Polygon(Object.assign({}, polyOptions, {
                type: feature.properties.type,
                fillColor: feature.properties.color,
                paths: transformToMVCArray(feature.geometry.coordinates),
                editable: false,
                locationId: tmplocationId
            }));
            break;
        case google.maps.drawing.OverlayType.POLYLINE:
            instance = new google.maps.Polyline(Object.assign({}, polyOptions, {
                type: feature.properties.type,
                strokeColor: feature.properties.color,
                path: transformToMVCArray([feature.geometry.coordinates]).getAt(0),
                draggable: true,
                editable: false,
                locationId: tmplocationId
            }));
            break;
        case google.maps.drawing.OverlayType.CIRCLE:

            instance = new google.maps.Circle(Object.assign({}, polyOptions, {
                type: feature.properties.type,
                fillColor: feature.properties.color,
                center: new google.maps.LatLng(feature.geometry.coordinates[1], feature.geometry.coordinates[0]),
                radius: feature.properties.radius,
                editable: false,
                locationId: tmplocationId
            }));
            break;

        default:
            console.error("Unhandled Type ", feature.properties.type, feature);
            break;
    }


    debug('instance',instance);

    return instance;
}

